// Formatos chilenos compartidos (es-CL, hora de Santiago).
const TZ = "America/Santiago";

// Fecha sin hora ("YYYY-MM-DD" de columnas date): se fija a mediodía para
// evitar el corrimiento de un día por zona horaria.
export function fmtFecha(d, opts = { day: "2-digit", month: "short", year: "numeric" }) {
  if (!d) return "—";
  const fecha = /^\d{4}-\d{2}-\d{2}$/.test(d) ? new Date(d + "T12:00:00") : new Date(d);
  if (Number.isNaN(fecha.getTime())) return "—";
  return fecha.toLocaleDateString("es-CL", { ...opts, timeZone: TZ });
}

// Fecha y hora de un timestamptz: "08-10-2026, 14:35".
export function fmtFechaHora(ts) {
  if (!ts) return "—";
  const f = new Date(ts);
  if (Number.isNaN(f.getTime())) return "—";
  return f.toLocaleString("es-CL", {
    day: "2-digit", month: "2-digit", year: "numeric",
    hour: "2-digit", minute: "2-digit", hour12: false, timeZone: TZ,
  });
}

// "hace 5 min", "hace 2 h", o la fecha si es más antiguo que 7 días.
export function fmtRelativo(ts, ahora = new Date()) {
  if (!ts) return "";
  const seg = Math.round((ahora - new Date(ts)) / 1000);
  if (seg < 60) return "recién";
  if (seg < 3600) return `hace ${Math.floor(seg / 60)} min`;
  if (seg < 86400) return `hace ${Math.floor(seg / 3600)} h`;
  if (seg < 7 * 86400) {
    const d = Math.floor(seg / 86400);
    return `hace ${d} día${d !== 1 ? "s" : ""}`;
  }
  return fmtFecha(ts);
}

export function diasRestantes(d) {
  if (!d) return null;
  return Math.ceil((new Date(d + "T12:00:00") - new Date()) / 864e5);
}
